import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';

import {UsatiComponent} from './usati.component';
import {UsatiListaComponent} from './usati-lista.component';
import {UsatiRoutingModule} from './usati-routing.module';

import {ConmetInputModule} from '../custom-component/conmet-input/conmet-input.module';
import {ConmetInputNumberModule} from '../custom-component/conmet-input-number/conmet-input-number.module';
import {ConmetSelectModule} from '../custom-component/conmet-select/conmet-select.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import {CurrencyPipe} from '@angular/common';

import {NgxGalleryModule} from '@kolkov/ngx-gallery';
import { VeicoloCardComponent } from './components/veicolo-card.component';
import { VeicoloCarouselComponent } from './components/veicolo-carousel.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UsatiRoutingModule,
    ReactiveFormsModule,
    ConmetInputModule,
    ConmetInputNumberModule,
    SweetAlert2Module.forChild(),
    ConmetSelectModule,
    NgxGalleryModule,
    NgbModule,
  ],
  declarations: [
    UsatiComponent,
    UsatiListaComponent,
    VeicoloCardComponent,
    VeicoloCarouselComponent,
  ],
  exports: [
    UsatiComponent,
    UsatiListaComponent,
    VeicoloCardComponent,
    VeicoloCarouselComponent,
  ],
  providers: [
    CurrencyPipe
  ]
})
export class UsatiModule {
}
